import Vue from 'vue'
import Vuex from 'vuex'
import Fuse from 'fuse.js'
import Chat from './Chat'
import { Perfil, atualizarStore } from './Perfil'
import { Flash } from './Flash'
import { Settings, updateStore as updateSettingsStore } from './Settings'
import { Bdc } from './Bdc'
import { meta } from '@App/Meta'

Vue.use(Vuex)

setInterval(() => {
    store.commit('setNow', new Date())
}, 1000)

export const store = new Vuex.Store({
    modules: { chat: Chat, settings: Settings, perfil: Perfil, flash: Flash, bdc: Bdc },
    state: {
        dicasHabilitadas: true,

        /**
         * Referência ao "agora" que atualiza a cada segundo.
         */
        now: new Date(),

        focoJanela: true,

        /**
         * Status da conexão websocket. Os valores podem ser: 'conectado', 'desconectado' ou 'inconsistente'.
         */
        statusWebsocket: 'conectado',

        /**
         * Registro serializado do usuário que está logado no sistema.
         */
        usuário: JSON.parse(meta('user')),

        urlPáginaAtual: document.location.href,

        mapaMundi: null,
        mapaMundiFuse: null,

        tags: [],
        tagsFuse: null,

        modoWidgets: 'operação',
    },
    getters: {
        pesquisarMapaMundi: state => query => {
            return state.mapaMundiFuse.search(query)
        },
        widgetsModoEdição: state => {
            return state.modoWidgets == 'edição'
        },
        widgetsModoOperação: state => {
            return state.modoWidgets == 'operação'
        },
        focadoNaEdiçãoDoWidget: state => key => {
            return state.modoWidgets.key == key
        },
    },
    mutations: {
        toggleDicasHabilitadas(state) {
            state.dicasHabilitadas = !state.dicasHabilitadas
        },

        /**
         * Atualiza o timestamp atual.
         */
        setNow(state, now) {
            state.now = now
        },

        atualizarFocoJanela(state, foco) {
            state.focoJanela = foco
        },

        /**
         * Atualiza o registro do usuário atual após atualizar algum atributo.
         */
        updateCurrentUser(state, user) {
            state.usuário = user
        },

        /**
         * Atualiza o status da websocket para o status especificado.
         */
        atualizarStatusWebsocket(state, status) {
            // Se o status passou a ser 'inconsistente', não há recuperação que não seja
            // recarregar o sistema.
            if (state.statusWebsocket == 'inconsistente') return

            state.statusWebsocket = status
        },

        atualizarUrlPáginaAtual(state, url) {
            state.urlPáginaAtual = url
        },

        toggleModoEdiçãoParaWidgets(state) {
            if (state.modoWidgets == 'operação') {
                state.modoWidgets = 'edição'
            } else {
                state.modoWidgets = 'operação'
            }
        },

        focarEmWidgetContainerParaEdição(state, key) {
            state.modoWidgets = { modo: 'edição_container', key: key }
        },

        atualizarMapaMundi(state, mapaMundi) {
            state.mapaMundi = mapaMundi

            state.mapaMundiFuse = new Fuse(
                mapaMundi.flatMap(módulo => módulo.páginas).filter(página => página.permissão),
                {
                    includeMatches: true,
                    threshold: 0.1,
                    keys: [
                        { name: 'nome', weight: 0.7 },
                        { name: 'descrição', weight: 0.3 },
                    ],
                }
            )
        },

        /**
         * Adiciona uma tag dinâmicamente na lista de tags após o carregamento.
         */
        addTag(state, tag) {
            state.tags.push(tag)
            state.tagsFuse = Object.freeze(
                new Fuse(state.tags, {
                    keys: ['nome'],
                })
            )
        },

        atualizarTags(state, tags) {
            state.tags = tags
            state.tagsFuse = Object.freeze(
                new Fuse(tags, {
                    keys: ['nome'],
                })
            )
        },
    },
    actions: {
        async carregarTags({ commit }) {
            let res = await axios.get('/core/tags?all')
            commit('atualizarTags', res.data)
        },
    },
})

atualizarStore(store)
updateSettingsStore(store)
